/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Text,
  Conditional,
  Popup,
  Space,
} from '@cashfree-intl/coherent';
import { CURRENCY_SYMBOL } from 'utils/constants';
import { MINIMUM_VENDOR_BALANCE } from '../../Vendors/constants';
import { DATE_FIELDS, DETAILS_DISPLAY_TEXT_MAPPING } from '../constants';
import {
  StyledDetailedValue,
  StyledDetailsContainer,
  StyledDetailsObject,
  StyledDisplayText,
  StyledPaper,
} from '../styled';
import { formatDate } from '../helpers';

export function VendorSettlementDetails({
  vendorIdData,
  enableSettleNow,
  handleSettleNowBtnCLick,
  lowBalance,
  settlementDetailsObj,
}) {
  return (
    <StyledPaper>
      <Space direction="column">
        <Space justifyContent="space-between" alignItems="center">
          <Text variant="h16" strong className="mb-4">
            Settlement Details
          </Text>
          <Conditional if={vendorIdData?.status === 'ACTIVE'}>
            {enableSettleNow ? (
              <Button
                secondary
                size="small"
                onClick={handleSettleNowBtnCLick}
                data-event-name="Form_VendorSettlementDetails_Button_SettleNow"
              >
                Settle Now
              </Button>
            ) : (
              <>
                <Conditional if={!lowBalance}>
                  <Button
                    primary
                    disabled
                    size="small"
                    onClick={handleSettleNowBtnCLick}
                    data-event-name="Primary_Button_SettleNow"
                  >
                    Settle Now
                  </Button>
                </Conditional>
                <Conditional if={lowBalance}>
                  <Popup
                    content={`Low balance. You can trigger On-Demand Settlements only for an amount greater than ${
                      CURRENCY_SYMBOL.INR
                    } ${MINIMUM_VENDOR_BALANCE}`}
                    trigger={
                      <span className="pointer">
                        <Button primary disabled>
                          Settle Now
                        </Button>
                      </span>
                    }
                    position="top center"
                  />
                </Conditional>
              </>
            )}
          </Conditional>
        </Space>
        <StyledDetailsContainer>
          {Object.keys(settlementDetailsObj).map(obj => (
            <StyledDetailsObject key={obj} gap={5} className="mb-2">
              <StyledDisplayText variant="b14" color="bodyLight">
                {DETAILS_DISPLAY_TEXT_MAPPING[obj]}
              </StyledDisplayText>
              <StyledDetailedValue variant="b14">
                {DATE_FIELDS.includes(obj)
                  ? formatDate(settlementDetailsObj[obj])
                  : settlementDetailsObj[obj]}
              </StyledDetailedValue>
            </StyledDetailsObject>
          ))}
        </StyledDetailsContainer>
      </Space>
    </StyledPaper>
  );
}

VendorSettlementDetails.propTypes = {
  vendorIdData: PropTypes.object.isRequired,
  enableSettleNow: PropTypes.func.isRequired,
  handleSettleNowBtnCLick: PropTypes.func.isRequired,
  lowBalance: PropTypes.bool.isRequired,
  settlementDetailsObj: PropTypes.object.isRequired,
};

export default VendorSettlementDetails;
